export function getNinetyNineHostKey(): string {
    return process.env.NEXT_PUBLIC_USE_STAGING === 'true' ? 'dev' : '99designs.com';
}
